module.exports = __webpack_public_path__ + "img/currency_blue.5434552d.png";